module.exports = __webpack_public_path__ + "img/menu_visa.c16e7cf5.png";